import { FC, useMemo } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useEquityMarket } from '../contexts/EquityMarketContext';

import EquityMarketWelcomeBanner from '../components/EquityMarketWelcomeBanner';
import EquityMarketKpiCards from '../components/EquityMarketKpiCards';
import EquityMarketCtaCards from '../components/EquityMarketCtaCards';
import EquityMarketSummaryCards from '../components/EquityMarketSummaryCards';
import EquityMarketRecentActivity from '../components/EquityMarketRecentActivity';
import EquityMarketReferenceInfo from '../components/EquityMarketReferenceInfo';

import '../styles/Trading.scss';

const WELCOME_BANNER_ENABLED = true;

const EquityMarket: FC = () => {
  const { t } = useTranslate();
  const { data } = useEquityMarket();

  useGetMenu(menuTypes.NULL);

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: data.societyName, to: `/sociedad/${data.societyId}` },
      { label: t('EquityMarket'), isActive: true },
    ],
    [t, data.societyName, data.societyId]
  );

  const pageActions = [<GoBackButton key="go-back" icon="ni-arrow-left" />];

  return (
    <Page id="equity-market-page">
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PageListHeader
        subTitle={t('EquityMarket')}
        description={t('EquityMarketDescription')}
        actions={pageActions}
      />

      {WELCOME_BANNER_ENABLED && <EquityMarketWelcomeBanner />}

      <EquityMarketKpiCards />
      <EquityMarketCtaCards />
      <EquityMarketSummaryCards />
      <EquityMarketRecentActivity />
      <EquityMarketReferenceInfo />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default EquityMarket;
